export default __webpack_public_path__ + "static/media/Cuisse of the Blood Drinker (nm).11a4e095.jpg";